import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize, fontSizeFromControlSize, heightFromControlSize } from 'utils'
import DndComponent from './dnd'

export const Dnd = styled(DndComponent)`
    border-radius: inherit;
`

export const Container = styled.div<{
    controlSize: ControlSize
    disabled: boolean
}>`
    align-items: center;
    display: flex;
    position: relative;
    user-select: none;

    ${({ controlSize, disabled }) => css`
        border-radius: ${borderRadiusFromControlSize(controlSize)}px;
        font-size: ${fontSizeFromControlSize(controlSize)}px;
        height: ${heightFromControlSize(controlSize)}px;

        ${disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
    `}
`
